import {createAction, SESSION_ID} from './types';

export const fetchSessionId = () => dispatch => {
    dispatch(createAction(SESSION_ID.FETCH_SESSION_ID_START));
    const sessionId = window.location.pathname.replace('/', '');
    return dispatch(createAction(SESSION_ID.FETCH_SESSION_ID_SUCCESS, {sessionId: sessionId}));
};